// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3kHVC","imageUploader":"EGiftCard_imageUploader__1KVSH"};